import BoardListHeader from '../../../../../ee/app/assets/javascripts/boards/components/board_list_header.vue?vue3';
import BoardAddNewColumn from '../../../../../ee/app/assets/javascripts/boards/components/board_add_new_column.vue?vue3';
import { isListDraggable } from '../boards_util';
import BoardList from './board_list.vue?vue3';
import BoardAddNewColumnBetween from './board_add_new_column_between.vue?vue3';
export default {
    name: 'BoardColumn',
    components: {
        BoardAddNewColumn,
        BoardAddNewColumnBetween,
        BoardListHeader,
        BoardList
    },
    props: {
        list: {
            type: Object,
            default: ()=>({}),
            required: false
        },
        boardId: {
            type: String,
            required: true
        },
        filters: {
            type: Object,
            required: true
        },
        highlightedLists: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        last: {
            type: Boolean,
            required: false,
            default: false
        },
        listQueryVariables: {
            type: Object,
            required: true
        },
        lists: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        canAdminList: {
            type: Boolean,
            required: false,
            default: false
        },
        columnIndex: {
            type: Number,
            required: true
        },
        draggedItemId: {
            type: String,
            required: false,
            default: null
        },
        focused: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'cannot-find-active-item',
        'drag-start',
        'drag-stop',
        'focus-adjacent',
        'highlight-list',
        'set-active-list',
        'set-filters'
    ],
    data () {
        return {
            showNewForm: false,
            showNewListForm: false
        };
    },
    computed: {
        createNewPosition () {
            if (this.list.position < 0) {
                return 0;
            }
            return this.list.position + 1;
        },
        highlighted () {
            return this.highlightedLists.includes(this.list.id);
        },
        isListDraggable () {
            return isListDraggable(this.list);
        },
        showAddNewListBetween () {
            return this.canAdminList && !this.last && !this.showNewListForm;
        },
        listQueryVariablesWithCreateNewPosition () {
            return {
                ...this.listQueryVariables,
                position: this.createNewPosition
            };
        }
    },
    methods: {
        toggleNewForm () {
            this.showNewForm = !this.showNewForm;
        },
        setShowNewListAfter (value) {
            this.showNewListForm = value;
        }
    }
};
